import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ReactLenis } from "lenis/react";
import { Toaster } from "@/components/ui/sonner";
import Landing from "@/pages/Landing";
import ServiceAreas from "@/pages/ServiceAreas";
import TownPage from "@/pages/TownPage";
import Legal from "@/pages/Legal";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import GalleryManager from "@/pages/GalleryManager";

function App() {
  return (
    <ReactLenis root options={{ lerp: 0.09 }}>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/service-areas" element={<ServiceAreas />} />
            <Route path="/areas/:slug" element={<TownPage />} />
            <Route path="/legal" element={<Legal />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="/admin/gallery" element={<GalleryManager />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" theme="dark" />
      </div>
    </ReactLenis>
  );
}

export default App;
